import React, { useState } from 'react';
import './style.css';
import clsx from 'clsx';

// type HeadersMap = Record<string, string>;

export interface HomePageModalProps {
  onAccepted?: () => void;
  privacyPolicyHref?: string;
  className?: string;
}

const HomePageModalProps = ({ onAccepted, privacyPolicyHref = '#', className }: HomePageModalProps) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleAccept() {
    try {
      setError(null);
      setSubmitting(true);
      if (onAccepted) onAccepted();
    } catch (err) {
      const msg =
        err && typeof err === 'object' && 'message' in (err as any)
          ? (err as any).message
          : 'Something went wrong while accepting the Terms.';
      setError(String(msg));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className={clsx('wrapper', className)}>
      <h2 className="tou-title">Terms of Use</h2>

      <div className="tou-body">
        <p>The data available to the public via CARA’s Upstream platform is subject to the following terms and conditions:</p>

        <ol className="tou-list">
          <li>
            Upstream and the data available through same are provided on an “as is” basis without warranties or representations
            of any kind, either express or implied, including, but not limited to, warranties of title or implied warranties of
            merchantability or fitness for a particular purpose.
          </li>
          <li>
            In no event shall the Center for Asset Retirement Accountability or the Resources Legacy Fund be liable for any
            special, direct, indirect, consequential, or incidental damages or any damages whatsoever arising out of or in
            connection with the use of Upstream or its contents.
          </li>
          <li>
            The Center for Asset Retirement Accountability retains all rights, title, and interest in and to the data
            compilation, the database structure, and the Upstream platform itself, including all associated intellectual
            property rights. The license granted herein is strictly limited to the uses permitted under these Terms.
          </li>
          <li>
            When using the data in any public-facing materials, you must cite the Center for Asset Retirement Accountability’s
            Upstream database as the source.
          </li>
          <li>
            By using Upstream, you agree to these Terms of Use and our{' '}
            <a className="tou-link" href={privacyPolicyHref} target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            .
          </li>
        </ol>

        <p className="tou-copy">
          © Copyright 2025 Center for Asset Retirement Accountability, a project of Resources Legacy Fund
        </p>

        {error && (
          <p role="alert" style={{ color: '#ff6b6b', marginTop: '0.75rem' }}>
            {error}
          </p>
        )}
      </div>

      <div className="tou-actions">
        <button type="button" className="tou-acceptBtn" onClick={handleAccept} disabled={submitting} aria-busy={submitting}>
          {submitting ? 'ACCEPTING…' : 'ACCEPT TERMS OF USE'}
        </button>
      </div>
    </div>
  );
};

export default HomePageModalProps;
